var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 17 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0C4.107 0 .443 3.539.443 8.057c0 1.718.517 3.251 1.508 4.687l5.932 9.257c.288.45.946.45 1.234 0l5.958-9.288a8.02 8.02 0 0 0 1.482-4.656C16.557 3.614 12.942 0 8.5 0m0 11.719a3.666 3.666 0 0 1-3.662-3.662A3.666 3.666 0 0 1 8.5 4.395a3.666 3.666 0 0 1 3.662 3.662A3.666 3.666 0 0 1 8.5 11.719"
  })));
};
export default SvgLocation;